module.exports = __webpack_public_path__ + "static/media/cProject-not-found.ff6ec679.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/cProject-not-found.png
// module id = 620
// module chunks = 0